import { toastService } from '@thefarmersfront/kitchen';

import { registerMockAPI } from '~/mocks/mockApis';

import { useAPI, useAsyncHandler } from '~/hooks/common';

import { TOAST_MESSAGE, type TypePickupShippingType } from '~/constants';

import type { TypeErrorResponseData } from '~/types/common.types';
import type { TypePatchOwnerSupplierShippingParams } from '~/types/vender.types';

const usePatchOwnerSupplierShipping = () => {
  const { runAsync } = useAsyncHandler();

  const patchOwnerSupplierShipping = useAPI<TypePatchOwnerSupplierShippingParams>({
    endpoint: '/api-owner/owner-supplier',
    method: 'patch',
  });

  const updateOwnerSupplierShipping = async (
    {
      ownerSupplierCode,
      shippingType,
      params,
    }: {
      ownerSupplierCode: string;
      shippingType: TypePickupShippingType;
      params: TypePatchOwnerSupplierShippingParams;
    },
    { onSuccess, onError }: { onSuccess?: () => void; onError?: () => void } = {}
  ) => {
    runAsync(
      () => patchOwnerSupplierShipping({ params, pathParams: `/${ownerSupplierCode}/shipping/${shippingType}` }),
      {
        onSuccess,
        onError: (error) => {
          toastService.addToast({
            type: 'error',
            message: (error as TypeErrorResponseData['error'])?.message || TOAST_MESSAGE.DEFAULT_ERROR,
          });
          onError?.();
        },
      }
    );
  };

  return { updateOwnerSupplierShipping };
};

export default usePatchOwnerSupplierShipping;

registerMockAPI<null>({
  method: 'patch',
  endpoint: '/api-owner/owner-supplier/:ownerSupplierCode/shipping/:shippingType',
  label: '입고/입고요청/출고지수정',
  scenarios: [
    { name: '정상 응답', response: null },
    {
      name: '서버 오류',
      response: { error: { message: '출고지 수정 중 오류가 발생했습니다.' } },
      status: 500,
    },
  ],
});
